import { RichText } from 'components/richText';
import { Wrapper } from '../wrapper';
import styles from './GameDetail.module.scss';
import { GameDetailSpecProps } from './gameDetailSpec/GameDetailSpec';
import { GameDetailSpecList } from './gameDetailSpecList';

export type GameDetailProps = {
  specs?: GameDetailSpecProps[];
  description: string;
  detailCardComponent: React.ReactNode;
  detailInfoComponent?: React.ReactNode;
  coverImageCaption?: string;
};

export const GameDetail = ({
  specs,
  description,
  detailCardComponent,
  detailInfoComponent,
  coverImageCaption,
}: GameDetailProps) => {
  return (
    <Wrapper noPaddingRight={true} noPaddingLeft={true}>
      <div className={styles.container}>
        {/** possibile componente card */}
        <section className={styles.cardContainer}>
          <div className={styles.card}>{detailCardComponent}</div>
          {coverImageCaption && <p className={styles.imageCaption}>{coverImageCaption}</p>}
        </section>
        <section className={styles.infoContainer}>
          {/** possibile componente specifiche */}
          {specs && <GameDetailSpecList specs={specs} />}
          {detailInfoComponent && detailInfoComponent}
          {/** possibile componente description */}
          {description && <RichText containerClassName={styles.descriptionText}>{description}</RichText>}
        </section>
      </div>
    </Wrapper>
  );
};
